export const DMS_MODULE = 'DialogueMarketing';
